import * as React from 'react'
import { Icon, Message, Balloon, Button } from '@alifd/next';
import * as fetchJsonp from 'fetch-jsonp';
import { useAppSelector } from '../../redux/hooks';
import openXman from '../../common/xman';
import doLog from '../../common/log';
import { getCookie } from '../../common/cookie';

const {useState} = React;

export default function AddCart(props: any) {
  const {selectSkuInfo, i18n, productId} = props;
  const skuInfo = useAppSelector(state => state.sku);

  const [tipShow, setTipShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');

  const addCart = async() => {
    if (selectSkuInfo.length > 20) {
      setDelayHide(i18n['undue_market_deal_add_shopping_cart.text_dialog_content']);
      setLoading(false);
      return;
    }
    const url = `//carp.alibaba.com/addPurchaseItem.jsonp?_tb_token_=${getCookie('_tb_token_')}&dmtrack_pageid=${window.dmtrack_pageid}&purchaseItemsData=${
      encodeURIComponent(
        JSON.stringify(selectSkuInfo.map((i:any) => ({
          productId,
          dispatchLocation: i.placeOfDispatchId,
          skuId: i.skuId,
          quantity: i.quantity
        })))
      )
  }`;
    // @ts-ignore: Unreachable code error
    const resultData = await fetchJsonp(url).then((res:any) => res.json());
    if (resultData.success === true) {
      setDelayHide(`${i18n["rightAction.addCart"]} ${i18n["undue_market_action.coupon.congratulations"]}`);
    }else{
      Message.error(resultData.message);
    }
    setLoading(false);
  }

  const setDelayHide = (val: string) => {
    setContent(val)
    setTipShow(true);
    setTimeout(() => {
      setTipShow(false);
    }, 2 * 1000);
  }

  const handleCart = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    doLog('/sc.details.cartBtn');
    doLog('/sc.migrate.event', `id=4056&pid=${productId}`);

    if (selectSkuInfo.length === 0) {
      setDelayHide(`${i18n['undue_tpl_helpers.text_deal_validate_quantity_top']} 0`);
      return;
    }
    setLoading(true);

    openXman(() => {
      addCart()
    }, ()=> {
      setTipShow(false)
      setLoading(false)
    })
  }


  return (
    <div className="add-cart" style={{
      display: skuInfo.addCart ? 'inherit' : 'none'
    }}>
      <Balloon
                trigger={
                  <Button text onClick={handleCart} size='large' loading={loading}><Icon type="add-cart"/> {i18n["rightAction.addCart"]}</Button>
              }
                align="tr"
                className="tip-show"
                alignEdge
                visible={tipShow}
                closable={false}
                triggerType="hover"
                style={{
                    width: 300
                }}
            >
                {content}
      </Balloon>
          
    </div>
  )
}
